import { Divider, Fab, Grid, IconButton, TextField, Typography } from '@mui/material';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export const DesplazamientosTarea = ({
    desplazamientos,
    setDesplazamientos,
    nuevoDesplazamiento,
    setNuevoDesplazamiento,
    idTarea,
    deleteDesplazamientoApi,
}) => {
    const crearDesplazamiento = () => {
        const comentario = String(nuevoDesplazamiento.comentario || '').trim();
        const cantidad = parseInt(nuevoDesplazamiento.cantidad, 10);

        if (comentario.length > 0 && cantidad > 0) {
            setDesplazamientos(prev => [...prev, { comentario, cantidad }]);
            setNuevoDesplazamiento({
                comentario: '',
                cantidad: 1
            });
        }
    };

    const borrarDesplazamiento = async (index, id) => {
        setDesplazamientos(prev => prev.filter((_, i) => i !== index));

        if (!id || !deleteDesplazamientoApi) return;

        try {
            const response = await deleteDesplazamientoApi(id, idTarea);

            if (response?.success) {
                setDesplazamientos(response.data || []);
            }
        } catch (error) {
            console.error('Error al eliminar desplazamiento:', error);
        }
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            xs={12}
            sx={{ mt: 2 }}
        >
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ textAlign: 'left', fontWeight: 700 }}>
                    Desplazamientos
                </Typography>
            </Grid>

            <Divider variant="middle" color="#aaaaaa" sx={{ minWidth: '100%', mb: 1 }} />

            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="center"
                xs={12}
                gap={1}
            >
                <Grid item xs={7}>
                    <TextField
                        label="Comentario..."
                        variant="filled"
                        fullWidth
                        size="small"
                        type="text"
                        value={nuevoDesplazamiento.comentario}
                        onChange={(event) => setNuevoDesplazamiento({
                            ...nuevoDesplazamiento,
                            comentario: event.target.value
                        })}
                    />
                </Grid>

                <Grid item xs={3}>
                    <TextField
                        label="Cantidad"
                        variant="filled"
                        fullWidth
                        size="small"
                        type="number"
                        inputProps={{ min: 1, step: 1 }}
                        value={nuevoDesplazamiento.cantidad}
                        onChange={(event) => {
                            const cantidad = Math.max(1, parseInt(event.target.value || 1, 10));
                            setNuevoDesplazamiento({
                                ...nuevoDesplazamiento,
                                cantidad
                            });
                        }}
                    />
                </Grid>

                <Fab size="small" color="primary" onClick={crearDesplazamiento}>
                    <AddIcon />
                </Fab>

                <Grid item xs={12}>
                    <Divider variant="middle" color="#aaaaaa" sx={{ minWidth: '10%' }} />
                </Grid>

                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={12}
                    gap={1}
                    sx={{ maxHeight: '24vh', overflow: 'auto', p: 1 }}
                >
                    {desplazamientos.map((desplazamiento, index) => (
                        <Grid
                            key={desplazamiento.id || index}
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            xs={12}
                            className="articulo-extra"
                            sx={{ p: 1 }}
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="start"
                                alignItems="center"
                                xs="auto"
                                gap={1}
                            >
                                <IconButton onClick={() => borrarDesplazamiento(index, desplazamiento.id)}>
                                    <DeleteForeverIcon />
                                </IconButton>
                                <Typography variant="subtitle1">
                                    {desplazamiento.comentario}
                                </Typography>
                            </Grid>

                            <Typography variant="subtitle1">
                                Cantidad: <strong>{parseInt(desplazamiento.cantidad || 0, 10)}</strong>
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};
